<template>
  <div>
    No Such Component
    <NoSuchComponent />
  </div>
</template>

<script>
export default {
  name: "error-no-such-component"
};
</script>
